import { render, staticRenderFns } from "./UpdateDelete.vue?vue&type=template&id=043875ba&"
import script from "./UpdateDelete.vue?vue&type=script&lang=js&"
export * from "./UpdateDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports